/**
 * Information API
 * @module api/info
 */

import Settings from '../settings';

const serverPath = Settings.serverPath;

/**
 * Gets luci info from the server.
 * @func getLuciInformation
 * @return {Promise<Object[]|Error>}
 */
// eslint-disable-next-line
export const getLuciInformation = () => fetch(`${serverPath}LuciInformationHandler.ashx`, {
  method: 'get',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
}).then(response => {
  if (response.ok) {
    return response.json();
  }
  throw (new Error('Response not ok.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting data from camio.  Bad JSON received.'));
  }
  return Promise.resolve(data);
})
.catch(error => { throw (new Error(`getAssets failed: ${error}`)); });



// WEBPACK FOOTER //
// ./app/api/info.js